export enum DomainType {
    assembly = 0,
    cooking,
    home_repair,
    gardening,
    household_maintenance,
    job_examples
  }